import { render, staticRenderFns } from "./TabHeaderBullentin.vue?vue&type=template&id=33ccf7fb"
import script from "./TabHeaderBullentin.vue?vue&type=script&lang=js"
export * from "./TabHeaderBullentin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports